<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="repeatServices"
      :pagination.sync="pagination"
      :hide-default-footer="true"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            <p>{{props.item.name}}</p>
          </td>
          <td>
            <p v-if="props.item.lead_passenger_name != null">{{props.item.lead_passenger_name}}</p>
          </td>
          <td>
            <p>{{props.item.user.id + " " + props.item.user.name}}</p>
          </td>
          <td>
            <div class="fixed-booking-table-row" v-if="props.item.pickup != null">
              <p>{{props.item.pickup}}</p>
            </div>
          </td>
          <td>
            <div
              v-if="props.item.destination != null"
              class="fixed-booking-table-row"
              v-html="props.item.destination"
            ></div>
          </td>
          <td>
            <v-row>
              <v-flex pb-1>
                <v-btn class="text-none" small ripple @click="goToRepeatService(props.item.id)">View</v-btn>
              </v-flex>
              <v-flex pb-1>
                <v-btn class="text-none" small ripple @click="editRepeatService(props.item)">Edit</v-btn>
              </v-flex>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

export default {
  name: "repeat_service_list",
  components: {
    ViasForBooking
  },
  props: {
    repeatServices: Array,
    paginationProp: Object
  },
  mounted: async function() {},
  data: function() {
    return {
      message: "",
      pagination: this.paginationProp,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Lead PAX",
          align: "left",
          sortable: false,
          value: "leadpax"
        },
        {
          text: "User",
          align: "left",
          sortable: false,
          value: "user"
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Vias",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Destinations",
          align: "left",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  methods: {
    goToRepeatService: function(id) {
      this.$router.push("/repeat_service/edit/" + id);
    },
    editRepeatService: function(item) {
      console.log(item.name);
      this.$emit("edit", item);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px !important;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
